import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-dispute-list',
  templateUrl: './admin-dispute-list.component.html',
  styleUrls: ['./admin-dispute-list.component.css']
})
export class AdminDisputeListComponent implements OnInit {

  public data = [
    {applicationId: 'AP234', contactPerson: 'Ramesh Singh', document: 'Marksheet', status: 'Open'},
    {applicationId: 'AP897', contactPerson: 'Vikas Patel', document: 'Degree', status: 'Solved'},
    {applicationId: 'AP556', contactPerson: 'Ratan Singh', document: 'Degree', status: 'Not a Dispute'},
  ];

  title = 'docVerificationList';
  dtOptions: DataTables.Settings = {};

  constructor() { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
  }

}
